module.exports = __webpack_public_path__ + "fb1ae88c874b7881aa0876247c7114be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/app-page/make-moves-together/cha-leaderboard.png
// module id = 1751
// module chunks = 1